module.exports = __webpack_public_path__ + "img/img2.00156c88.png";